angular.module('controllers').controller('driverLoginController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', 'Crud', 'Mqtt',
	function ($scope, $rootScope, $controller, $route, $routeParams, $location, Crud, Mqtt) {

		$rootScope.path = '/driver-login';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'driver-login';
		$scope.pathTemplate = 'distribution/driverlogins';
		$scope.title = 'Istoric logare soferi';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'created_at';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'driver_name':{'label':'Sofer', 'filter':1, 'filterType':'input'},
			'device_version':{'label':'Versiune', 'filter':1, 'filterType':'input'},
			'device_imei':{'label':'Identificator imei', 'filter':1, 'filterType':'input'},
			'device_uuid':{'label':'Identificator uuid', 'filter':1, 'filterType':'input'},
			'device_imsi':{'label':'Serie cartela', 'filter':1, 'filterType':'input'},
			'device_platform':{'label':'Platforma', 'filter':1, 'filterType':'input'},
			'created_at':{'label':'Data', 'filter':1, 'filterType':'input'}
		};

		$scope.additionals = [];
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'driver_name';

	}]
);
